
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telemedicine/request",
      function () {
        return require("private-next-pages/telemedicine/request/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telemedicine/request"])
      });
    }
  